export const NotificationIds = {
  HomeFinancingSimulation: 'showHomeFinancingSimulation',
  HomeFinancingIndication: 'showHomeFinancingIndication',
  HomeRefinancingDocuments: 'showHomeRefinancingDocuments',
  AutoRefinancingDeactiveCreation: 'showAutoRefinancingDeactiveCreation',
}
